__turbopack_context__.v({
  "container": "_6e19MW_container",
  "item": "_6e19MW_item",
  "list": "_6e19MW_list",
  "listContainer": "_6e19MW_listContainer",
  "runner": "_6e19MW_runner",
  "title": "_6e19MW_title",
  "titleIcon": "_6e19MW_titleIcon",
  "titleText": "_6e19MW_titleText",
});
